<template>
  <nav :class="['sidebarMenu', variant ? `sidebarMenu--${variant}` : '']">
    <div class="sidebarMenu__top">{{ title }}</div>
    <ul class="sidebarMenu__list">
      <li class="sidebarMenu__listItem" v-for="(link, index) in links" :key="`link-${index}`">
        <nuxt-link v-if="link.url" :to="link.url" class="sidebarMenu__listItemLink">{{
          link.name
        }}</nuxt-link>
        <nuxt-link
          v-else-if="link.slug"
          :to="
            localePath({
              name: link.slug.name,
              params: { slug: link.slug.value },
            })
          "
          class="sidebarMenu__listItemLink"
          >{{ link.name }}</nuxt-link
        >
        <a
          v-else-if="link.href"
          :href="link.href"
          target="_blank"
          rel="nofollow"
          class="sidebarMenu__listItemLink"
          >{{ link.name }}</a
        >
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'SidebarMenu',
  props: {
    title: {
      type: String,
      default: '',
    },
    links: {
      type: Array,
      default: () => [],
    },
    variant: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.sidebarMenu {
  $root: &;
  width: 100%;
  background-color: $cWhite;

  &__top {
    padding: 2rem;
    font-size: 1.6rem;
    line-height: 2rem;
    font-weight: 600;
    border-bottom: 1px solid $cAddLight;
  }

  &__list {
    padding: 2rem;
  }

  &__listItemLink {
    display: block;
    padding: 0.6rem 0;
    font-size: 1.4rem;
    line-height: 2.2rem;
    color: $cMainLight;
    width: 100%;
    transition: color $tr;

    &:hover,
    &.nuxt-link-active {
      color: $cSec;
    }
  }

  &--page {
    #{$root}__list {
      @include rwd('large-tablet') {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -1rem;
      }
    }

    #{$root}__listItemLink {
      padding: 0.6rem 1rem;
    }
  }
}
</style>
